export const extractDriveId = (url) => {
   if (!url?.includes("/file/d/")) return ""

   const idStart = url.indexOf("/file/d/") + 8
   const idEnd = url.indexOf("/", idStart)
   return idEnd !== -1 ? url.slice(idStart, idEnd) : url.slice(idStart)
}
